import { ActionMenuItem } from '@if/mui'
import { ECreditApplicationStatus } from '@if/core/types'
import { ECurrentCustomerStep } from '@src/types/Constants'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export function useCreditApplicationStatuses() {
  const { t } = useTranslation()

  return useMemo(
    () => [
      <ActionMenuItem key={ECreditApplicationStatusFilters.All} value={ECreditApplicationStatusFilters.All}>
        {t('common.all')}
      </ActionMenuItem>,
      <ActionMenuItem key={ECreditApplicationStatusFilters.Active} value={ECreditApplicationStatusFilters.Active}>
        {t('creditApplicationStatus.active')}
      </ActionMenuItem>,
      <ActionMenuItem key={ECreditApplicationStatusFilters.Cancelled} value={ECreditApplicationStatusFilters.Cancelled}>
        {t('creditApplicationStatus.cancelled')}
      </ActionMenuItem>,
      <ActionMenuItem key={ECreditApplicationStatusFilters.Completed} value={ECreditApplicationStatusFilters.Completed}>
        {t('creditApplicationStatus.completed')}
      </ActionMenuItem>,
      <ActionMenuItem key={ECreditApplicationStatusFilters.Draft} value={ECreditApplicationStatusFilters.Draft}>
        {t('creditApplicationStatus.draft')}
      </ActionMenuItem>,
      <ActionMenuItem key={ECreditApplicationStatusFilters.Expired} value={ECreditApplicationStatusFilters.Expired}>
        {t('creditApplicationStatus.expired')}
      </ActionMenuItem>,
    ],
    [t],
  )
}

export function useCurrentCustomerSteps() {
  const { t } = useTranslation()

  return useMemo(
    () => [
      <ActionMenuItem key={ECurrentCustomerStep.Prequal} value={ECurrentCustomerStep.Prequal}>
        {t('dashboardEntriesStatus.prequal')}
      </ActionMenuItem>,
      <ActionMenuItem key={ECurrentCustomerStep.Credit} value={ECurrentCustomerStep.Credit}>
        {t('dashboardEntriesStatus.credit')}
      </ActionMenuItem>,
      <ActionMenuItem key={ECurrentCustomerStep.IncomeVerification} value={ECurrentCustomerStep.IncomeVerification}>
        {t('dashboardEntriesStatus.incomeVerification')}
      </ActionMenuItem>,
      <ActionMenuItem key={ECurrentCustomerStep.Contract} value={ECurrentCustomerStep.Contract}>
        {t('dashboardEntriesStatus.contract')}
      </ActionMenuItem>,
      <ActionMenuItem key={ECurrentCustomerStep.Funding} value={ECurrentCustomerStep.Funding}>
        {t('dashboardEntriesStatus.funding')}
      </ActionMenuItem>,
    ],
    [t],
  )
}

export enum ECreditApplicationStatusFilters {
  Active = ECreditApplicationStatus.Active,
  Cancelled = ECreditApplicationStatus.Cancelled,
  Completed = ECreditApplicationStatus.Completed,
  Draft = ECreditApplicationStatus.Draft,
  Expired = ECreditApplicationStatus.Expired,
  All = 'all',
}
